import React, { FC } from 'react'
import styles from './style.module.scss'

type LoadingProps = {
  fullScreen?: boolean
}

const Loading: FC<LoadingProps> = ({ fullScreen = false }) => {
  if (fullScreen) {
    return (
      <div className={styles.fullScreen} data-testid="loading-spinner">
        <div className={styles.spinner} />
      </div>
    )
  }

  return <div className={styles.spinner} />
}

export default Loading
